import type { Media } from "./types.ts";

/** `1.1.02-108-B.jpg` + `abcd12` → `1.1.02-108-B.abcd12.jpg`. */
export function hashedName(file: string, hash: string | undefined): string {
  if (!hash) return file;
  const dot = file.lastIndexOf(".");
  return dot === -1
    ? `${file}.${hash}`
    : `${file.slice(0, dot)}.${hash}${file.slice(dot)}`;
}

/** Public URL for a question's image or film. */
export function mediaUrl(media: Media): string {
  const dir = media.kind === "video" ? "videos" : "images";
  return `/media/${dir}/${hashedName(media.file, media.hash)}`;
}
